import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

const tabData = [
   {
      id: '01ete',
      title: '01. eLearning Platform Development',
      intitle: 'eLearning Platform Development',
      icon: '/assets/svg/industries/education/01.svg',
      content:
         'We create rich-featured online learning platforms with live classes, interactive quizzes, progress tracking, and AI-based personalized learning to make education more accessible. Our platforms enable video conferencing, real-time whiteboarding, and interactive polls to make virtual classrooms more engaging. We integrate adaptive learning paths, gamified assessments, and multimedia content libraries. With AI-powered recommendations, real-time progress tracking, and certification management, we create scalable and accessible learning ecosystems.',
   },
   {
      id: '02ete',
      title: '02. Learning Management System (LMS) Development',
      intitle: 'Learning Management System (LMS) Development',
      icon: '/assets/svg/industries/education/02.svg',
      content:
         'Our bespoke LMS solutions allow learning institutions to handle courses, monitor learner progress, grade automatically, and manage collaborative work easily. We develop LMS sites with course authoring tools, drag-and-drop editors, and multi-media capabilities. Our solutions provide role-based access, automated reports, and compliance monitoring. With video conferencing, assessment, and third-party API integrations, we improve learning effectiveness and user engagement.',
   },
   {
      id: '03ete',
      title: '03. AI-Powered EdTech Solutions',
      intitle: 'AI-Powered EdTech Solutions',
      icon: '/assets/svg/industries/education/03.svg',
      content:
         'Our education software based on AI offers individualized learning pathways, automated guidance, intelligent assessments, and predictive insights to enhance student achievement. We use machine learning algorithms for adaptive learning modules, personalized content suggestions, and dynamic skill measurement. Our products include AI-based chatbots for real-time assistance, automated marking of essays, and plagiarism checks. Educators are equipped with predictive insights into student performance trends and learning gaps.',
   },
   {
      id: '04ete',
      title: '04. School & College Management Software',
      intitle: 'School & College Management Software',
      icon: '/assets/svg/industries/education/04.svg',
      content:
         'Our platforms include student information systems (SIS), automatic gradebooks, and bespoke reporting tools. We develop complete school ERP systems that simplify admissions, attendance tracking, scheduling, fee administration, and parent-teacher communication. We integrate payment gateways for fee collection, automated notifications for schedule changes, and mobile access for parents. With data security, role-based access, and real-time analytics, we enhance educational administration efficiency.',
   },
   {
      id: '05ete',
      title: '05. Exam & Assessment Software',
      intitle: 'Exam & Assessment Software',
      icon: '/assets/svg/industries/education/05.svg',
      content:
         'We build secure online examination platforms with AI-based proctoring, automated grading, and detailed performance analytics for accurate student evaluations. Our solutions feature real-time monitoring, facial recognition, and behavior tracking to prevent cheating. We offer customizable exam templates, question banks, and adaptive testing options. With instant grading, detailed score reports, and skill-based analytics, educators can assess student progress effectively.',
   },
   {
      id: '06ete',
      title: '06. Mobile Learning Apps (mLearning)',
      intitle: 'Mobile Learning Apps (mLearning)',
      icon: '/assets/svg/industries/education/06.svg',
      content:
         'Our proprietary e-learning mobile apps provide learning experiences on the go with offline capabilities, adaptive content delivery, and push notifications for customized study plans. We design apps with interactive courses, gamified challenges, and microlearning modules. Our solutions include offline downloads, progress sync across devices, and real-time quizzes. With AI-based learning recommendations and in-app certifications, we empower users with flexible and engaging mobile learning experiences.',
   },
];

function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Innovative Education Software Development Solutions
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               Being a top education software development firm, we design personalized e-learning solutions that equip institutions, teachers, and learners with engaging, scalable, and AI-powered learning tools. Our experience guarantees smooth learning processes, effective administration, and cutting-edge content delivery. Explore our comprehensive education software development services:
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
